"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../shared/components/editors/CardRowNumericEditor");
var GameSetBetTargetEditor = /** @class */ (function (_super) {
    __extends(GameSetBetTargetEditor, _super);
    function GameSetBetTargetEditor(props) {
        return _super.call(this, props) || this;
    }
    GameSetBetTargetEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    amount: _item.avg_bet_amount,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Список ставок фриспинов", "Редактирование ставок фриспинов"]);
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                amount: 0,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список ставок фриспинов", "Создание ставок фриспинов"]);
            });
        }
        this.doReSetRules();
    };
    GameSetBetTargetEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false },
            amount_rules: { isError: false }
        });
    };
    GameSetBetTargetEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        if ((!this.state.amount) || (this.state.amount <= 0)) {
            this.setState({ amount_rules: { isError: true, errorMessage: "Сумма не заполнена!" } });
            return false;
        }
        return true;
    };
    GameSetBetTargetEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                // app_currency_id: this.state.app_currency_id,
                avg_bet_amount: this.state.amount,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Ставка фриспинов для набора игр изменена!");
            });
        }
    };
    GameSetBetTargetEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.state.app_currency_id,
                cms_gameset_id: this.props.rootRecord.key,
                avg_bet_amount: this.state.amount
                //description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Ставка фриспинов для набора игр добавлена!");
            });
        }
    };
    GameSetBetTargetEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    GameSetBetTargetEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая ставка фриспинов";
        }
        else {
            return "Изменить ставку фриспинов";
        }
    };
    GameSetBetTargetEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 290 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules, disabled: this.props.record != null }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Ставка фриспинов:", placeholder: "Введите значение ставки фриспинов" }, values: { max: 999999, min: 1, value: this.state.amount }, precision: 2, onValueChanged: function (newVal) {
                    _this.setState({
                        amount: newVal
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return GameSetBetTargetEditor;
}(React.Component));
exports.default = GameSetBetTargetEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/component/fsbettargets/GameSetBetTargetEditor.tsx
// module id = 2007
// module chunks = 0